import { isWelcomeAboardFunnelClassCourseId } from '@onark/shared/welcomeAboardFunnelClass';

/**
 * The PostHog distinctId for a checked-in guest.
 *
 * Guests of the OnArk-owned funnel classes (the WA master, and BOTH trainings:
 * /onark/online-class and /onark/training) are OnArk's own leads: every server-side funnel event about them
 * (onark_training_started / _part_completed / _completed, see
 * apps/api/src/welcomeAboard/funnelClassCio.ts) uses their normalized email as
 * distinctId. Identifying the browser with that SAME id is what merges their
 * in-player pageviews/autocapture onto that person — keyed by guest uuid they
 * land on a second, unmerged person and the per-part funnel goes blind.
 *
 * A customer church's guests keep the guest-uuid key: their email must not
 * become an OnArk-side analytics identity (same boundary as the C.io gate).
 * Admin (staff) check-ins keep the uuid too — staff walking the class must not
 * pollute the lead funnel.
 */
export function guestAnalyticsDistinctId(checkIn: {
  adminCheckIn?: boolean | null;
  courseId?: string | null;
  guest?: { email?: string | null; id: string } | null;
}): string {
  const guest = checkIn.guest;

  if (!guest) return '';

  const email = guest.email?.trim().toLowerCase();

  if (
    email &&
    isWelcomeAboardFunnelClassCourseId(checkIn.courseId) &&
    !checkIn.adminCheckIn
  ) {
    return email;
  }

  return guest.id;
}
